import { useMemo, useContext } from 'react';

//@ts-ignore
import CustomBranding from '@mindtickle/custom-branding';

//@ts-ignore
import Scrollbar from '@mindtickle/scrollbar';

import { useHeaderOffset } from '~/components/Header';
import { LocalAuthContext } from '~/components/Auth';

import { StyledLayout } from './styles';

import Header from '~/components/Header';
import Sidebar from '~/components/Sidebar';

function Layout({ children }: { children: JSX.Element }) {
  const offset = useHeaderOffset();
  const auth = useContext(LocalAuthContext);

  const scrollProps = useMemo(
    () => ({
      autoHeight: true,
      autoHeightMin: `calc(100vh - ${offset}px)`,
      autoHeightMax: `calc(100vh - ${offset}px)`,
      style: { flex: 1, minWidth: '320px' },
      hideTracksWhenNotNeeded: true,
    }),
    [offset]
  );

  return (
    <CustomBranding brandColor={auth?.company?.brandColor}>
      <StyledLayout $offset={offset}>
        <div className="header">
          <Header />
        </div>
        <div className="shell-layout-learner-content">
          <Sidebar />
          <Scrollbar {...scrollProps}>{children}</Scrollbar>
        </div>
      </StyledLayout>
    </CustomBranding>
  );
}

export default Layout;
